import { darken, lighten, transparentize } from "polished";
import styled, { css } from "styled-components";

type Props = {
  size?: number;
  badge?: string;
  children?: React.ReactNode;
  secondary?: boolean;
};

export function IconFrame({ size = 40, badge, children, secondary }: Props) {
  return (
    <Container $size={size} $secondary={secondary}>
      {children}
      {badge && <Badge $size={size} src={badge} alt="" />}
    </Container>
  );
}

export const Container = styled.div<{ $size: number; $secondary?: boolean }>`
  color: ${props => props.theme.buttonText};
  display: flex;
  justify-content: center;
  align-items: center;

  position: relative;

  background: linear-gradient(
    315deg,
    ${props => darken(0.1, props.theme.button)} 0%,
    ${props => lighten(0.1, props.theme.button)} 130%
  );

  ${props =>
    props.$secondary &&
    css`
      background: ${transparentize(0.9, props.theme.link)};
    `}

  border-radius: 100%;

  width: ${props => props.$size}px;
  min-width: ${props => props.$size}px;
  height: ${props => props.$size}px;

  svg {
    width: ${props => props.$size / 2}px;
    height: ${props => props.$size / 2}px;
  }
`;

const Badge = styled.img<{ $size: number }>`
  position: absolute;
  width: ${props => props.$size / 2.2}px;
  height: ${props => props.$size / 2.2}px;

  bottom: -${props => props.$size / 16}px;
  right: -${props => props.$size / 16}px;
`;
